import { fetchBalance } from "../utils/api";
import { useState, useEffect } from "react";
import { TBalance } from "../utils/types";

export const useBalance = () => {
  const [balance, setBalance] = useState<TBalance | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const getBalance = async () => {
    setError("");
    try {
      const res = await fetchBalance();
      setBalance(res.data);
    } catch (err) {
      console.error("Receiving balance failed:", err);
      setError("Receiving balance failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    setError("");
    getBalance();
  }, []);

  return {
    balance,
    loading,
    error,
    setError,
    getBalance,
  };
};
